export default "__VITE_ASSET__D7q3$nu0__"